import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';

const Logo = ({ variant, className, ...rest }) => {
  // Variant is 'symbol'
  if (variant === 'symbol') {
    return (
      <svg
        viewBox="0 0 160 213"
        preserveAspectRatio="xMinYMin meet"
        fill="none"
        className={[
          styles.svg,
          className,
        ].join(' ')}
        {...rest}
      >
        <path
          className={styles['logo-100']}
          d="M159.616 106.592V137.947C159.616 149.962 149.848 159.73 137.834 159.73H106.478L122.596 124.663L159.616 106.592Z"
        />
        <path
          className={styles['logo-200']}
          d="M106.478 106.592L71.1181 124.175L53.4381 159.632H106.478L159.616 106.592V53.4542L138.81 58.8266L106.478 106.592Z"
        />
        <path
          className={styles['logo-300']}
          d="M106.478 53.4542V106.592L159.616 53.4542V0.41391L128.945 11.3541L106.478 53.4542Z"
        />
        <path
          className={styles['logo-300']}
          d="M0.300052 159.632V212.77L53.438 159.632L106.478 106.592H53.438L26.869 114.114L0.300052 159.632Z"
        />
        <path
          className={styles['logo-400']}
          d="M106.478 0.41391L54.9033 19.4615L53.4381 53.4542H106.478L159.616 0.41391H106.478Z"
        />
        <path
          className={styles['logo-400']}
          d="M0.300052 159.632L53.438 106.592V53.4542L16.3196 61.464L0.300052 106.592V159.632Z"
        />
        <path
          className={styles['logo-500']}
          d="M53.438 0.41391L17.6871 10.6703L0.300052 53.4542V106.592L53.438 53.4542L106.478 0.41391H53.438Z"
        />
        <path
          className={styles['logo-600']}
          d="M0.300052 53.4542V22.0989C0.300052 10.0842 10.0681 0.316217 22.0827 0.316217H53.438L0.300052 53.4542Z"
        />
      </svg>
    );
  }

  // Variant is 'horizontal'
  return (
    <svg
      viewBox="0 0 641 121"
      preserveAspectRatio="xMinYMin meet"
      fill="none"
      className={[
        styles.svg,
        className,
      ].join(' ')}
      {...rest}
    >
      <path
        className={styles.text}
        d="M161.461 2.815h-28.995v87.83h12.809l-.141-31.388h16.186c40.678 0 40.819-56.442.141-56.442zm-16.327 11.26h15.764c24.069 0 23.787 34.062-.141 34.062h-15.764l.141-34.062zM217.903 2.534h-12.386v88.251h12.386V2.534zM333.883 52.078c-8.305-1.689-12.809-5.067-12.809-9.57 0-4.505 4.645-7.602 11.12-7.602 4.926 0 9.148 1.971 14.356 6.334l.423.423 6.756-8.586-.423-.422c-5.911-5.63-13.793-8.727-21.957-8.727-13.371 0-22.661 7.6-22.661 18.298 0 10.415 7.178 17.171 21.394 19.846 9.431 1.83 13.794 5.067 13.794 10.275 0 5.348-4.926 8.867-12.527 8.867-6.615 0-12.949-3.097-17.453-8.304l-.422-.563-7.179 8.445.282.422c5.911 6.897 15.06 10.838 25.335 10.838 14.498 0 24.209-7.882 24.209-19.565.141-10.697-7.178-17.453-22.238-20.409zM425.231 25.335h-12.386v65.31h12.386v-65.31zM419.038 0c-4.504 0-8.023 3.378-8.023 8.023 0 4.504 3.519 7.882 8.023 7.882s8.023-3.519 8.023-7.882c0-4.504-3.519-8.023-8.023-8.023zM490.118 73.332c-4.927 4.926-11.12 7.6-17.454 7.6-12.667 0-22.661-9.993-22.661-22.942 0-12.809 9.994-22.943 22.661-22.943 6.053 0 11.823 2.393 17.031 7.038l.423.422 6.474-9.852-.422-.282c-6.615-5.63-14.779-8.586-23.787-8.586-19.706 0-35.329 15.06-35.329 34.203 0 19.142 15.483 34.203 35.329 34.203 9.712 0 18.298-3.378 24.913-9.712l.422-.422-7.319-9.15-.281.423zM523.757 25.335h-12.386v65.31h12.386v-65.31zM517.564 0c-4.504 0-8.023 3.378-8.023 8.023 0 4.504 3.519 7.882 8.023 7.882s8.023-3.519 8.023-7.882c0-4.504-3.378-8.023-8.023-8.023zM627.21 25.335l-18.72 48.7-18.579-48.7h-13.09l25.335 64.606-11.26 28.713-.281.845h12.949l36.314-93.32.422-.844h-13.09zM568.376 80.792c-1.267.14-3.801.281-5.63.281-8.305 0-11.964-3.378-11.964-11.541V36.313h17.594v-11.12h-17.594V7.883h-12.386V69.672c0 15.342 7.459 22.38 23.364 22.38 2.534 0 5.349-.282 6.756-.563l.423-.14V80.51l-.563.282zM397.503 80.792c-1.267.14-3.801.281-5.63.281-8.305 0-11.964-3.378-11.964-11.541V36.313h17.594v-11.12h-17.594V7.883h-12.387V69.672c0 15.342 7.46 22.38 23.365 22.38 2.534 0 5.349-.282 6.756-.563l.423-.14V80.51l-.563.282zM283.212 25.335v6.194c-4.645-4.505-12.105-7.742-19.283-7.742-18.72 0-33.358 15.06-33.358 34.203 0 19.142 14.638 34.203 33.358 34.203 7.46 0 14.497-2.815 19.283-7.601v6.052h12.386V25.335h-12.386zm-17.453 55.598c-12.668 0-22.662-9.994-22.662-22.943 0-12.809 9.994-22.943 22.662-22.943 6.896 0 13.23 3.238 17.453 8.445v29.136c-4.223 5.208-10.416 8.305-17.453 8.305z"
      />
      <path
        className={styles['logo-100']}
        d="M88.552 61.509V78.82c0 6.616-5.349 12.105-12.105 12.105H59.134l8.868-19.424 20.55-9.993z"
      />
      <path
        className={styles['logo-200']}
        d="M59.135 61.509L39.57 71.22l-9.853 19.705h29.418l29.417-29.417V32.092L77.01 35.047 59.134 61.51z"
      />
      <path
        className={styles['logo-300']}
        d="M59.135 32.092v29.417l29.417-29.417V2.674L71.52 8.727 59.135 32.092zM.3 90.926v29.417l29.417-29.417 29.418-29.417H29.717L15.08 65.59.3 90.925z"
      />
      <path
        className={styles['logo-400']}
        d="M59.135 2.674L30.562 13.231l-.845 18.86h29.418L88.552 2.675H59.134zM.3 90.926l29.417-29.417V32.092l-20.55 4.504L.3 61.508v29.417z"
      />
      <path
        className={styles['logo-500']}
        d="M29.717 2.674L10.012 8.445.3 32.092v29.417l29.417-29.417L59.135 2.674H29.717z"
      />
      <path
        className={styles['logo-600']}
        d="M.3 32.092V14.779C.3 8.164 5.65 2.674 12.405 2.674h17.312L.3 32.092z"
      />
    </svg>
  );
};

Logo.defaultProps = {
  variant: 'horizontal',
  className: '',
};

Logo.propTypes = {
  variant: PropTypes.oneOf(['horizontal', 'symbol']),
  className: PropTypes.string,
};

export default Logo;
